import { InputControl } from "./input-control";

export class TimeInput extends InputControl {

    formatValue() {
        // Convert to AM/PM format
        const value = this.getValue();
        if (!value) { 
            return ''; 
        } 
        
        const [hours, minutes] = value.split(':').map(Number);
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert 0 or 13-23 to 12-hour format
        return `${formattedHours}:${minutes.toString().padStart(2, '0')} ${period}`;
    }
}
